import { List } from 'antd';
import React, { FC, ReactNode } from 'react';
import { Sticky } from 'react-sticky';
import styled from 'styled-components';
import { Channel, Configuration } from 'api/notifications';
import { useHeaderHeight } from 'components/molecules/page';
import { Mandatory } from '../group';
import { useChannels } from './channels';
import { ConfigurationView } from './configuration-view';
import { Header } from './header';

interface Props {
  mandatory?: Mandatory[];
  group: string;
  icon: ReactNode;
  configurations: Configuration[];
  onChange: (configuration: Configuration) => void;
  showHeaders?: boolean;
}

const StyledList = styled(List)`
  margin-bottom: var(--layout-04);

  /** We probably have to reset this at ant list level */
  .ant-list-item {
    padding: 0;
  }
`;

const StickyWrapper = styled.div`
  background: var(--white-100);
  border-bottom: 1px solid var(--border-color);
  z-index: var(--zindex-modal-lowest);
`;

export const Section: FC<Props> = ({
  group,
  mandatory = [],
  icon,
  configurations,
  showHeaders,
  onChange,
}) => {
  const headerHeight = useHeaderHeight();
  const channelEnabledMap = useChannels();
  const channels = Object.keys(channelEnabledMap) as Channel[];

  return (
    <div>
      <Sticky relative topOffset={-(headerHeight + 25)}>
        {({ style, isSticky }) => (
          <StickyWrapper style={{ ...style, top: headerHeight }}>
            <Header
              group={group}
              icon={icon}
              options={channels}
              showHeaders={isSticky || showHeaders}
            />
          </StickyWrapper>
        )}
      </Sticky>
      <StyledList>
        {configurations.map((configuration) => (
          <List.Item key={configuration.eventType}>
            <ConfigurationView
              mandatory={mandatory.find(
                (value) => value.eventType === configuration.eventType,
              )}
              configuration={configuration}
              onChange={onChange}
            />
          </List.Item>
        ))}
      </StyledList>
    </div>
  );
};
